'use client';

import { useSession } from 'src/services/state/providers/SessionProvider';

import { useTranslations } from 'next-intl';
import React, { useEffect, useState } from 'react';

export function SessionTimeoutOverlay(): React.JSX.Element | null {
  const session = useSession();
  const t = useTranslations('components.Header');
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    if (!session?.session?.expiresAt) return;

    const msUntilExpired = new Date(session.session.expiresAt).getTime() - Date.now();
    if (msUntilExpired <= 0) {
      setExpired(true);
      return;
    }

    const timer = setTimeout(() => setExpired(true), msUntilExpired);
    return () => clearTimeout(timer);
  }, [session?.session?.expiresAt]);

  if (!expired) return null;

  return (
    <div className="usa-modal-wrapper is-visible">
      <div className="usa-modal-overlay">
        <div
          className="usa-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="session-timeout-heading"
          tabIndex={-1}
        >
          <div className="usa-modal__content">
            <div className="usa-modal__main text-center">
              <h2 className="usa-modal__heading" id="session-timeout-heading">
                {t('session_timeout_heading')}
              </h2>
              <div className="usa-prose">
                <p>{t('session_timeout_body')}</p>
              </div>
              <div className="usa-modal__footer">
                <a href={`${process.env.NEXT_PUBLIC_BASE_PATH}/login`} className="usa-button">
                  {t('session_timeout_button')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
